<script setup lang="ts">

import WebsiteLayout from "@layouts/website-layout.vue";
import OurMaterials from "./sections/our-materials.vue";
import {onMounted, PropType} from "vue";
import {ProductsInterface} from "@interfaces/ProductsInterface.js";
import Blogs from "./sections/blogs.vue";
import {BlogInterface} from "@interfaces/BlogInterface.js";
import Products from "./sections/products.vue";
import AllCategoriesHeader from "./sections/all-categories-header.vue";
import {usePage} from "@inertiajs/vue3";
import {PagePropsInterface} from "@interfaces/PagePropsInterface.js";
import AppHead from "@layouts/sections/app-head.vue";

defineOptions({
    layout: WebsiteLayout,
})

let page = usePage<PagePropsInterface>();

const props = defineProps({
    preConfigs: {
        type: Array as PropType<ProductsInterface[]>,
        required: true,
    },
    blogs: {
        type: Array as PropType<BlogInterface[]>,
        required: true,
    },
    category_slug: {
        type: String,
        required: true
    }
});

onMounted(() => {
    page.props.headerOptions = {
        transparent: true,
        inverted: false,
    }
});

</script>
<template>
    <AppHead title="Standing desks"></AppHead>
    <div id="page-all">
        <all-categories-header>
        </all-categories-header>
        <products
            :category_slug="props.category_slug"
            :preconfigs="props.preConfigs"
            >
        </products>
        <our-materials></our-materials>
        <blogs
            :blogs="props.blogs"
        ></blogs>
    </div>
</template>
<style scoped lang="scss">
@use "@scss/pages/category/all";
</style>
